import { Route, Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import RouteGuard from 'components/AuthenticatedLayout/RouteGuard/RouteGuard'

import { useHasSitesOnProduction } from '../../store'
import EmptyScreen from 'packages/ui/EmptyScreen/EmptyScreen'

import Advertisements from './Advertisements'
import Card from './Card/Card'
import RemoveAdvertisement from './Deletion/RemoveAdvertisment'
import Edit from './Edit'
import Export from './Actions/AdvertisementsExport'
import React from 'react'

const Layout = () => {
  const {t} = useTranslation()
  const hasSitesOnProduction = useHasSitesOnProduction()
  return (
    <RouteGuard requiredRoles={['portal_advertisement']}>
      {
        hasSitesOnProduction
          ? <Outlet />
          : <EmptyScreen icon="square-poll-vertical">{t('ui_elements.service_soon')}</EmptyScreen>
      }
    </RouteGuard>
  )
}

const AdvertisementsRoute = () => [
  <Route path="advertisements" key="advertisements" element={<Layout />}>
    <Route path="" element={<Advertisements />}>
      <Route path="create" element={<Edit />}></Route>
      <Route path="export" element={<Export />}></Route>
      <Route path=":id" element={<Card />}>
        <Route path="edit" element={<Edit />}></Route>
        <Route path="delete" element={<RemoveAdvertisement />}></Route>
      </Route>
    </Route>
  </Route>
]

export default AdvertisementsRoute
